// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
require('../internals/add-to-unscopables')('flat');
